import React from 'react';

// File icon — used in UploadScreen and UploadedFiles
export const FILE_ICON_SVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M9.333 1.333H4a1.333 1.333 0 0 0-1.333 1.334v10.666A1.333 1.333 0 0 0 4 14.667h8a1.333 1.333 0 0 0 1.333-1.334V5.333L9.333 1.333Z"
      stroke="#687281"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.333 1.333v4h4"
      stroke="#687281"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Download icon — used on Export button in KBEditor
export const DOWNLOAD_ICON_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.667 10.667v2a.667.667 0 0 0 .666.666h9.334a.667.667 0 0 0 .666-.666v-2M8 2.667v7.666M5.333 7.667 8 10.333l2.667-2.666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Upload icon — used on Upload files button in KBEditor
export const UPLOAD_ICON_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.667 10.667v2a.667.667 0 0 0 .666.666h9.334a.667.667 0 0 0 .666-.666v-2M8 2v8M5.333 4.667 8 2l2.667 2.667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Info-circle icon — processing banner
export const INFO_CIRCLE_ICON_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7" stroke="#357fef" strokeWidth="1.5" />
    <path
      d="M8 7.333v3.334"
      stroke="#357fef"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="8" cy="5.333" r="0.667" fill="#357fef" />
  </svg>
);

// Check-circle icon — success banner
export const CHECK_CIRCLE_ICON_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7" stroke="#16A34A" strokeWidth="1.5" />
    <path
      d="M4.5 8.5L6.5 10.5L11.5 5.5"
      stroke="#16A34A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Info/tooltip icon — used next to topic names in KBEditor
export const INFO_ICON_SVG = (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M8 7.333v3.334M8 5.333v.667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

// Topic status icons — used in Sidebar
export const TOPIC_COMPLETE_ICON_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7" stroke="#4CAF50" strokeWidth="1.5" />
    <path
      d="M4.5 8.5L6.5 10.5L11.5 5.5"
      stroke="#4CAF50"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Close (×) icon — used in version history panel header
export const CLOSE_ICON_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M12 4L4 12M4 4l8 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TOPIC_INCOMPLETE_ICON_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7" stroke="#687281" strokeWidth="1.5" />
    <path
      d="M4.5 8.5L6.5 10.5L11.5 5.5"
      stroke="#687281"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Upload illustration — concentric circles + upload arrow, used in UploadScreen drop zone
// Note: className prop is used for positioning by the parent
export const UPLOAD_ILLUSTRATION_SVG = (className: string) => (
  <svg
    width="104"
    height="104"
    viewBox="0 0 104 104"
    fill="none"
    className={className}
  >
    <circle cx="52" cy="52" r="52" fill="#f1f5f9" />
    <circle cx="52" cy="52" r="28" fill="#FFFFFF" />
    <g transform="translate(44, 42)">
      <path
        d="M8 2v9M5 5l3-3 3 3"
        stroke="#0f172a"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 11v1.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V11"
        stroke="#0f172a"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
